import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import { InhouseGameDetails } from 'config/types/game'
import useForceUpdate from 'hooks/useForceUpdate'
import useModal from 'hooks/useModal'
import { useCallback, useRef } from 'react'
import styled from 'styled-components'
import { WHEEL_PAYOUTS } from 'views/InhouseGame/Wheel/config'
import { WheelBet } from 'views/InhouseGame/Wheel/config/types'
import { useWheelCompletedBetListener } from 'views/InhouseGame/Wheel/hooks'
import InhouseGameBetDetailsModal from 'views/Profile/Transactions/components/Bet/InhouseGameBetDetailsModal'

const UserPayoutUpdater = ({ subscribe }) => {
  useWheelCompletedBetListener(subscribe)

  return null
}

const WheelResultHistory: React.FC<{ game: InhouseGameDetails } & BoxProps> = ({ game, ...props }) => {
  const betHistoryRef = useRef<WheelBet[]>([])

  const [onPresent] = useModal(InhouseGameBetDetailsModal)
  const { update: forceUpdate } = useForceUpdate()

  const subscribe = useCallback(
    (bet) => {
      betHistoryRef.current = betHistoryRef.current.slice(0, 6)
      betHistoryRef.current.unshift(bet)
      forceUpdate()
    },
    [forceUpdate],
  )

  return (
    <Flex {...props} width="100%" flexDirection="row-reverse" minHeight="30px">
      <UserPayoutUpdater subscribe={subscribe} />
      {betHistoryRef?.current.map((item, index) => {
        const isWinBet = item.result > 0

        const payouts = WHEEL_PAYOUTS[item.risk][item.segments]
        const selectedPayout = payouts?.find((payout) => payout.payout === item.result)

        return (
          selectedPayout && (
            <StyledPayoutContainer
              onClick={() => {
                const multiplier = isWinBet ? item.result : 0

                onPresent({
                  betTxn: {
                    bet: {
                      amount: item.betAmount.amount.toString(10),
                      token: item.betAmount.token,
                      amountInUsd: item.betAmount.amount.toString(10),
                    },
                    game,
                    multiplier,
                    payout: {
                      amount: item.betAmount.amount.multipliedBy(multiplier).toString(10),
                      token: item.betAmount.token,
                      amountInUsd: item.betAmount.amount.multipliedBy(multiplier).toString(10),
                    },
                    providerBetIdRef: Number(item.id),
                  },
                })
              }}
              key={`wheel-bet-history-item-${item.id}`}
              ml="12px"
              style={{ opacity: index > 5 ? 0 : 1 }}
              background={selectedPayout.color}
            >
              {item.result}x
            </StyledPayoutContainer>
          )
        )
      })}
    </Flex>
  )
}

const StyledPayoutContainer = styled(Box)`
  border-radius: ${({ theme }) => theme.radii.extraLarge};
  padding: 8px 0px;
  width: 52px;
  min-width: 52px;
  text-align: center;
  color: ${({ theme }) => theme.colors.textTertiary};
  font-size: 12px;
  font-weight: 600;
  overflow: hidden;
  animation: expand 0.5s;
  transition: 0.2s;
  cursor: pointer;

  &:hover {
    transform: scale(1.1);
  }

  @keyframes expand {
    0% {
      margin-right: -52px;
    }

    100% {
      margin-right: 0px;
    }
  }
`

export default WheelResultHistory
